<template>
  <div>
    <div class="mb-10">
      <button class="btn btn-sm line-2" @click="$emit('load-procedures')">
        <i class="icon-refresh mr-5"></i>작업 항목에서 불러오기
      </button>
      <span class="text-888 ml-10" style="font-size:11px;">작업위험성평가의 작업 항목을 기반으로 자동 채웁니다. 불필요한 행은 삭제하세요.</span>
    </div>
    <div class="btn-wrap mb-10">
      <button class="btn btn-md light-blue" @click="addRow">
        <i class="icon-plus mr-5"></i>행 추가
      </button>
    </div>
    <table class="tbl select-tbl">
      <colgroup>
        <col style="width:50px;"><col style="width:140px;"><col><col><col><col><col style="width:150px;"><col><col style="width:80px;">
      </colgroup>
      <thead class="no-drag">
        <tr>
          <th>순번</th>
          <th>항목</th>
          <th>작업절차(세부작업순서)</th>
          <th><span class="ess">위험요인</span></th>
          <th>재해유형</th>
          <th><span class="ess">현재 안전보건조치</span></th>
          <th>위험도(상/중/하)</th>
          <th>추가 안전보건조치</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(proc, idx) in procedures" :key="idx">
          <td style="text-align:center;">{{ idx + 1 }}</td>
          <td><input type="text" class="form-control" v-model="proc.item"></td>
          <td><input type="text" class="form-control" v-model="proc.procedure"></td>
          <td><input type="text" class="form-control" v-model="proc.riskFactor"
                :style="(rowInUse(proc) && !(proc.riskFactor || '').trim()) ? { borderColor:'#eb5757' } : {}"></td>
          <td><input type="text" class="form-control" v-model="proc.hazard"></td>
          <td><input type="text" class="form-control" v-model="proc.currentMeasure"
                :style="(rowInUse(proc) && !(proc.currentMeasure || '').trim()) ? { borderColor:'#eb5757' } : {}"></td>
          <td style="vertical-align:middle;">
            <div class="td-box" style="display:flex;align-items:center;gap:6px;">
              <Dropdown v-model="proc.riskLevel" :datasource="riskLevelOptions" displayName="label" valueName="value" :isSelectionFirstData="false" :width="70"/>
              <span v-if="proc.riskLevel" class="wp-risk-badge" :class="'wp-risk-badge-' + getRiskLevelKey(proc.riskLevel)">{{ proc.riskLevel }}</span>
            </div>
          </td>
          <td><input type="text" class="form-control" v-model="proc.additionalMeasure"></td>
          <td style="text-align:center;">
            <button class="btn btn-xs line-2" @click="removeRow(idx)" :disabled="procedures.length === 1">삭제</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown.vue';

export const createProcedure = () => ({
  item: '',
  procedure: '',
  riskFactor: '',
  hazard: '',
  currentMeasure: '',
  riskLevel: '',
  additionalMeasure: ''
});

export default {
  name: 'WorkProcedureTable',
  components: { Dropdown },
  props: {
    procedures: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      riskLevelOptions: [
        { label: '상', value: '상' },
        { label: '중', value: '중' },
        { label: '하', value: '하' }
      ]
    };
  },
  methods: {
    rowInUse(p) {
      return !!(String(p.item || '').trim() || String(p.procedure || '').trim() || String(p.riskFactor || '').trim()
        || String(p.hazard || '').trim() || String(p.currentMeasure || '').trim()
        || String(p.riskLevel || '').trim() || String(p.additionalMeasure || '').trim());
    },
    getRiskLevelKey(level) {
      if (level === '상') return 'high';
      if (level === '중') return 'mid';
      if (level === '하') return 'low';
      return '';
    },
    addRow() {
      this.procedures.push(createProcedure());
    },
    removeRow(idx) {
      if (this.procedures.length <= 1) return;
      this.procedures.splice(idx, 1);
    }
  }
}
</script>